// BT-117478  : Implementing edge cases : Manasa B : 13/09/2023 - Start
import { memo, useEffect, useState,  useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { BzModalBody, BzModal, BzModalHeader, BzModalTitle, BzButton, BzModalFooter,  BzChip } from '../../components';
import { WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import { handleModal } from '../../redux/actions/modals';
import { setArrScripToBeAdded } from '../../redux/actions/globalSearch';
import { getscripCountPerWatchlist, getScripDisplayDescription } from '../../utils/global_functions';
import { toastConfig } from '../../redux/actions/toast';

const GlobalSearchRemoveExtraScripModal = ({ arrExistingScrips, objSelectedWatchList, setObjSelectedWatchList, isShow, setIsShow, arrGlobalScripts, ...props }) => {
    const dispatch = useDispatch();

    const modals = useSelector(state => state?.modals?.modals);
    const [selectedValues, setSelectedValues] = useState([]);
    const [arrScrips, setArrScrips] = useState([]);
    const arrScripsToBeAdded = useSelector(state => state?.globalSearch?.arrScripsToBeAdded);
    const { appInfo } = useSelector(state => state.appInfo);

    useEffect(() => {
        if (arrScripsToBeAdded?.length > 0) {
            const arrScripSymbol = arrScripsToBeAdded?.map(eachScrip => {
                return `${eachScrip[WATCHLIST_GRID_INDEX.SYMBOL]} ${eachScrip[WATCHLIST_GRID_INDEX.EXCHANGE]} ${eachScrip[WATCHLIST_GRID_INDEX.SERIES]} ${eachScrip[WATCHLIST_GRID_INDEX.TOKEN]}`;
            });
            setSelectedValues(arrScripSymbol);
            setArrScrips([...arrScripsToBeAdded]);
        }
    }, [arrScripsToBeAdded]);

    const handleClose = () => {
        dispatch(handleModal([{ "GLOBAL_SEARCH_REMOVE_EXTRASCRIPS_MODAL": false }]));
    };
    const handleCheckboxChange = (value, e) => {
        if (selectedValues?.includes(value)) {
            setSelectedValues(selectedValues.filter(eachValue => eachValue !== value));
        }
        else {
            setSelectedValues([...selectedValues, value]);
        }

        if (selectedValues?.includes(value)) {

            if (e.target.checked) {
            }
            else {
                let scripValue = e.target.value.split(',');
                let arrWLScrips = [...arrScrips];
                let updatedScrips = arrWLScrips.filter(eachScrip => JSON.stringify(eachScrip[WATCHLIST_GRID_INDEX.TOKEN]) !== scripValue[1]);
                setArrScrips(updatedScrips);
            }

        }
    };

    //BT-117478:Breeze - Global Search Feature- Azeem k 03-11-2023 --start
    const handleDone = () => {
        const arrFilteredScrips = arrScripsToBeAdded?.filter((item) => {
            return selectedValues?.includes(`${item[WATCHLIST_GRID_INDEX.SYMBOL]} ${item[WATCHLIST_GRID_INDEX.EXCHANGE]} ${item[WATCHLIST_GRID_INDEX.SERIES]} ${item[WATCHLIST_GRID_INDEX.TOKEN]}`);
        });
        if (arrFilteredScrips?.length < 1) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: `Atleast 1 scrip should  select.` }));
        } else {
            dispatch(handleModal([{ "GLOBAL_SEARCH_REMOVE_EXTRASCRIPS_MODAL": false }]));
            dispatch(setArrScripToBeAdded([...arrFilteredScrips]));
        }

    };
    //BT-117478:Breeze - Global Search Feature -Azeem k 03-11-2023 --end

    const nMaxScripToBeAdd = useMemo(() => {
        return getscripCountPerWatchlist();
    }, [appInfo]);


    return (
        <BzModal size='md' right show={modals['GLOBAL_SEARCH_REMOVE_EXTRASCRIPS_MODAL']} onHide={handleClose}>
            <BzModalHeader className='p-0'>
                <Container fluid className='px-3 py-2 bdr-btm'>
                    <Row className='g-0'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <BzModalTitle data-testid="add-to-watchlist-remove-extrascrips-modal-title-label" className='font-medium font-size5 color-text'>Review &amp; Add Scrips</BzModalTitle>
                        </Col>
                        <Col md={2} className='d-flex justify-content-end align-items-center'>
                            <div data-testid='add-to-watchlist-remove-extrascrips-modal-close-icon' className='icon-16 icon-close icon-dark' onClick={handleClose}></div>
                        </Col>
                    </Row>
                    <Row className='g-0 mt-2'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-medium font-size4 color-text me-2'>{`${objSelectedWatchList?.sWatchListName}`}</div>
                            <div className='font-regular font-size4 color-subtext'>({`${objSelectedWatchList?.scrips?.length}`} Scrips)</div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody className='bdr-btm'>
                <Container fluid className='p-0'>
                    <Row className='g-0 mb-3'>
                        <Col className='d-flex justify-content-start align-items-start'>
                            <div className='font-regular font-size4 color-subtext'>
                                You can add only {nMaxScripToBeAdd - objSelectedWatchList.scrips?.length} more scrips to this watchlist
                            </div>
                        </Col>
                    </Row>
                    {arrScripsToBeAdded?.length ? arrScripsToBeAdded?.map((eachScrip, i) =>
                        <Row className='g-0 py-2' key={i}>
                            <Col className='d-flex justify-content-start align-items-center'>
                                <input type="checkbox" data-testid={`add-to-watchlist-extra-scrips-input-${i}`} className='form-check-input me-2 m-0'
                                    checked={selectedValues?.includes(`${eachScrip[WATCHLIST_GRID_INDEX.SYMBOL]} ${eachScrip[WATCHLIST_GRID_INDEX.EXCHANGE]} ${eachScrip[WATCHLIST_GRID_INDEX.SERIES]} ${eachScrip[WATCHLIST_GRID_INDEX.TOKEN]}`)}
                                    onChange={(e) => handleCheckboxChange(`${eachScrip[WATCHLIST_GRID_INDEX.SYMBOL]} ${eachScrip[WATCHLIST_GRID_INDEX.EXCHANGE]} ${eachScrip[WATCHLIST_GRID_INDEX.SERIES]} ${eachScrip[WATCHLIST_GRID_INDEX.TOKEN]}`, e)}
                                    value={eachScrip} />
                                <div className='font-medium font-size4 color-text text-uppercase me-2'>{eachScrip[WATCHLIST_GRID_INDEX.SYMBOL]}</div>
                                <div className='chips-wrap'>
                                    <BzChip className='exchange-chip me-2'>{eachScrip[WATCHLIST_GRID_INDEX.EXCHANGE]}</BzChip>
                                </div>
                                <div className='font-regular font-size4 color-text'>{getScripDisplayDescription(eachScrip)}</div>
                            </Col>
                        </Row>
                    ) : null
                    }
                </Container>
            </BzModalBody>
            <BzModalFooter className='p-3'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={10} className='d-flex justify-content-start align-items-center'>
                            <div className='font-regular font-size3 color-subtext me-2'>Add to Watchlist</div>
                            <div className='font-medium font-size3 color-text me-2'>{`${objSelectedWatchList?.sWatchListName}`}</div>
                            <div data-testid='add-to-watchlist-remove-extrascrips-modal-count-label' className='number-badge'>{objSelectedWatchList?.scrips?.length + selectedValues?.length}</div>
                            <div className='icon-20 icon-info icon-negative ms-2'></div>
                        </Col>
                        <Col md={2} className='d-flex justify-content-end align-items-center'>
                            <BzButton data-testid='add-to-watchlist-remove-extrascrips-modal-done-button' className='btn btn-md btn-block btn-primary text-uppercase' disabled={objSelectedWatchList?.scrips?.length + selectedValues?.length > nMaxScripToBeAdd} onClick={handleDone}>Done</BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal>
    );
};

export default memo(GlobalSearchRemoveExtraScripModal);
// BT-117478  : Implementing edge cases : Manasa B : 13/09/2023 - End